export default __webpack_public_path__ + "static/media/switch_param_demo.f62956ee.png";